import React from 'react';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartFormatIndianNumber from "../../../Common/ChartFormatIndianNumber";
import NoDataFound from '../../NoDataFound/NoDataFound'

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const FulfillmentChart = ({ chartData }) => {
  if (!Array.isArray(chartData) || chartData.length === 0) {
    return <NoDataFound height={300} />;
  }

  const labels = chartData.map(item => item.fulfillment.toUpperCase());
  const dataValues = chartData.map(item => item.quantity);

  const data = {
    labels,
    datasets: [
      {
        label: 'Quantity',
        data: dataValues,
        backgroundColor: (ctx) => {
          const chart = ctx.chart;
          const { ctx: canvasCtx, chartArea } = chart;
          if (!chartArea) return;
          const gradient = canvasCtx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
          gradient.addColorStop(0, '#ff5e78');
          gradient.addColorStop(1, '#ffbd69');
          return gradient;
        },
        borderRadius: 20,
        barThickness: 15
      }
    ]
  };

  const options = {
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false
    },
    maintainAspectRatio: false, // Important to allow height control
    plugins: {
      tooltip: {
        mode: 'index',
      intersect: false,
        callbacks: {
          label: ctx => `Quantity: ${ChartFormatIndianNumber(ctx.raw)}`
        }
      },
      legend: {
        display: false
      },
      datalabels: {
        display: false   //  This disables all inline datalabels
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
        },
        ticks: {
          callback: (value) => ChartFormatIndianNumber(value)
        }
      }
    }
  };

  return (
    <div style={{ height: 360 }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default FulfillmentChart;
